import { Api } from "../api";

const api = new Api("api/amo/review");

export const getLastAuditedYear = async () => {
  try {
    const response = await api.get("reconciliation/last-update/");
    return response.data || 0;
  } catch {
    return 0;
  }
};
